import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { normalizeTimestamp } from "../../utils/dateUtils";

export default function ActiveUsersCard() {
  const [activeUsers, setActiveUsers] = useState(null);

  useEffect(() => {
    async function loadActiveUsers() {
      try {
        const now = new Date();
        const last24h = new Date(now.getTime() - 24 * 60 * 60 * 1000);

        const snap = await getDocs(collection(db, "users"));

        let count = 0;

        snap.forEach((doc) => {
          const u = doc.data();
          const lastActive = normalizeTimestamp(u.lastActiveAt);

          if (lastActive && lastActive >= last24h) {
            count++;
          }
        });

        setActiveUsers(count);
      } catch (err) {
        console.error("Erro ao buscar usuários ativos hoje:", err);
        setActiveUsers(0);
      }
    }

    loadActiveUsers();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Usuários ativos hoje</p>

      <p className="metric-value">
        {activeUsers !== null ? activeUsers.toLocaleString("pt-BR") : "--"}
      </p>

      <span className="metric-tag">Últimas 24h</span>
    </div>
  );
}
